import { action } from 'easy-peasy';
import { IActionUpdateUser } from '../types';

const updateUser: IActionUpdateUser = action((state, payload) => {
  const { id } = payload;
  state.items = state.items.map(item => {
    if (item.id === id) {
      return {
        ...item,
        ...payload,
      };
    }

    return item;
  });
});

export default updateUser;
